<template>
  <v-card :href="value.href" class="fill-height d-flex flex-column" rounded="0">
    <v-img
      :aspect-ratio="aspectRatio"
      :sizes="imgResp.sizes"
      :src="imgResp.src"
      :srcset="imgResp.srcset"
      alt="Photo for service differentiator"
      cover
      max-height="180"
      style="position: relative"
    >
      <v-avatar
        v-if="typeof value.icon === 'string'"
        class="ma-4"
        size="50"
        style="border-color: black; border-width: 2px"
        rounded="0"
        variant="outlined"
      >
        <v-icon :icon="`hdl:${value.icon}`" color="black" size="32" />
      </v-avatar>

      <div
        class="bg-surface service-differentiators-clip-path-bottom"
        style="position: absolute; bottom: -1px; right: -1px"
      ></div>
    </v-img>

    <div class="pa-4">
      <v-card-item v-if="value.title" class="text-h5">
        <StyledText :value="value.title" />
      </v-card-item>

      <v-card-text
        v-if="value.content"
        class="text-body-1"
        style="line-height: 150%"
      >
        <ContentBlock
          :value="value.content"
          em-class="text-decoration-underline"
        />
      </v-card-text>
    </div>
  </v-card>
</template>

<script setup>
import { toRef } from 'vue'
import { useImgResponsive } from '#root/lib/img'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 4 / 2
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      md: '800px'
    }
  }))
)
</script>

<style lang="scss" scoped>
.service-differentiators-clip-path-bottom {
  height: calc(var(--clip-offset));
  width: 100%;
  z-index: 0;

  clip-path: polygon(0 100%, 100% calc(100% - (var(--clip-offset))), 100% 100%);
  -webkit-clip-path: polygon(
    0 100%,
    100% calc(100% - (var(--clip-offset))),
    100% 100%
  );
}
</style>
